import React, { useEffect, useState, useContext } from "react";
import { Select } from "antd";
import "./styles.css";
import LeadContext from "../../contexts/leads";

const { Option } = Select;

function SearchPlaces({ states }) {
  const [search, setSearch] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const { supplyApi } = useContext(LeadContext);

  useEffect(() => {
    getPlaces(query);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const getPlaces = async query => {
    setLoading(true);
    supplyApi.get(`search/location/?q=${query}`).then(response => {
      var places = [
        ...response.data.districts,
        ...response.data.states,
        ...response.data.countries
      ];
      setSearch(places);
      setLoading(false);
    });
  };

  const toPlace = place => {
    if (place.state) {
      var state = states && states.find(x => x.id === place.state);
      window.location.href = `/${state.slug}/${place.slug}`;
    }
    if (place.country) {
      window.location.href = `/${place.slug}`;
    }
    if (place.iso2_code) {
      window.location.href = `/${place.slug}`;
    }
  };

  return (
    <Select
      className="search"
      showSearch
      size={"large"}
      suffixIcon={<i className="fa fa-map-marker-alt" />}
      placeholder={"Search any village, district or state"}
      allowClear={true}
      onSearch={e => setQuery(e)}
      loading={loading}
      showArrow={true}
      notFoundContent={"No place found with this name."}
    >
      {search &&
        search.map((place, index) => {
          return (
            <Option key={index} value={place.name}>
              <span
                style={{ paddingRight: 300 }}
                onClick={() => toPlace(place)}
              >
                {place.name}
              </span>
            </Option>
          );
        })}
    </Select>
  );
}

export default SearchPlaces;
